import { Component, Input } from '@angular/core';
import { Chip } from 'src/app/components/common-components/model/chip.model';
import { DOMAIN_FILTER_CHIPS } from 'src/app/components/domain-navigation/constants/domain-filter-chips.constants';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';

@Component({
    selector: 'app-rubric-domain-filter',
    templateUrl: './rubric-domain-filter.component.html',
    styleUrls: ['./rubric-domain-filter.component.scss']
})
export class RubricDomainFilterComponent {
    @Input() filterType?: DomainFilterType;
    @Input() showTargetUser: boolean = false;
    @Input() showTeacherFilter:boolean = false;
    @Input() canShowHistorical: boolean = false;
    @Input() showHistoricalFilter: boolean = false;
    @Input() includeFocusAreasFilter: boolean = false;
    DOMAIN_FILTER_CHIPS = DOMAIN_FILTER_CHIPS;

    ngOnInit() {
        if(!this.includeFocusAreasFilter){
            this.DOMAIN_FILTER_CHIPS = DOMAIN_FILTER_CHIPS.filter(chip => chip.Value !== DomainFilterType.FOCUS_AREAS);
        }
    }

    readonly hideUserChips: Chip<boolean>[] = [
        { Label: 'On', Value: false },
        { Label: 'Off', Value: true },
    ];

    readonly hideHistoricalChips: Chip<boolean>[] = [
        { Label: 'On', Value: true },
        { Label: 'Off', Value: false },
    ];

}
